import { render, staticRenderFns } from "./product1.vue?vue&type=template&id=4b8fd024&scoped=true"
import script from "./product1.vue?vue&type=script&lang=js"
export * from "./product1.vue?vue&type=script&lang=js"
import style0 from "./product1.vue?vue&type=style&index=0&id=4b8fd024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8fd024",
  null
  
)

export default component.exports